import { useVisualContext } from "Contexts/VisualContext";
import useSessionNavigate from "Hooks/useSessionNavigate";

const useDelayedNavigate = () => {
  const { setTransition } = useVisualContext();
  const { sessionNavigate } = useSessionNavigate();

  const delayedNavigate = (to, delay) => {
    if (!delay) {
      return sessionNavigate(to);
    }

    setTransition("transitionOut");
    setTimeout(() => {
      sessionNavigate(to);
      setTransition(null);
    }, delay);
  };

  return {
    delayedNavigate,
  };
};

export default useDelayedNavigate;